/* SRIX · Generation 0, vanilla interactions (no frameworks, no build step) */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Animate only when the page is genuinely visible and allowed to.
     Otherwise everything stays visible (content is never hidden without JS,
     and background/hidden renders never get stuck mid-transition). */
  var willAnimate = document.visibilityState === "visible" &&
                    !reduceMotion &&
                    ("IntersectionObserver" in window);

  /* ---------- mobile menu ---------- */
  var toggle = document.getElementById("menuToggle");
  var menu = document.getElementById("mobileMenu");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      toggle.setAttribute("aria-expanded", String(open));
    });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) menu.classList.remove("open");
    });
  }

  /* ---------- count-up numbers ---------- */
  function setFinal(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    el.textContent = isNaN(target) ? el.textContent : target.toLocaleString();
  }
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    if (isNaN(target)) return;
    var dur = 1100, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toLocaleString();
    }
    requestAnimationFrame(step);
  }

  /* ---------- reveal on scroll (+ trigger count-ups) ---------- */
  var io = null;
  if (willAnimate) {
    document.documentElement.classList.add("reveal-anim");
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          entry.target.querySelectorAll("[data-count]").forEach(countUp);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    /* static path: show final numbers immediately, leave content visible */
    document.querySelectorAll("[data-count]").forEach(setFinal);
  }

  /* ---------- dot field: a still grid of small teal circles that warps
       toward the cursor, the dots nearest the pointer lean in, swell and
       brighten, as if reaching up out of the screen, then spring back ---------- */
  function initDotField(canvas) {
    if (canvas.dataset.srixInit) return;
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    canvas.dataset.srixInit = "1";
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, dots = [];

    var GAP = 42;        /* grid spacing in px (tightened on narrow screens) */
    var DOT_R = 1.5;     /* resting radius */
    var REACH = 190;     /* cursor influence radius */
    var PULL = 34;       /* max px a dot travels toward the cursor */
    var STIFF = 190;     /* spring constant back to the grid position */
    var DAMP = 14;       /* under-damped, so releasing gives a small bounce */
    var TEAL = "39,96,103";

    var mx = -99999, my = -99999;

    function build() {
      var rect = canvas.getBoundingClientRect();
      W = rect.width; H = rect.height;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var gap = W < 640 ? 32 : GAP;
      var cols = Math.max(2, Math.floor(W / gap));
      var rows = Math.max(2, Math.floor(H / gap));
      /* centre the grid so the margins match on both sides */
      var ox = (W - cols * gap) / 2 + gap / 2;
      var oy = (H - rows * gap) / 2 + gap / 2;

      dots = [];
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          dots.push({
            bx: ox + c * gap, by: oy + r * gap,  /* home position */
            dx: 0, dy: 0,                        /* current offset from home */
            vx: 0, vy: 0,                        /* spring velocity */
            lift: 0                              /* 0..1, how far "out of the screen" */
          });
        }
      }
    }

    function render() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < dots.length; i++) {
        var n = dots[i];
        var x = n.bx + n.dx, y = n.by + n.dy;
        var l = n.lift;
        var rad = DOT_R * (1 + l * l * 2.6);
        ctx.globalAlpha = 0.30 + l * 0.70;
        ctx.fillStyle = "#276067";
        if (l > 0.25) {
          ctx.shadowColor = "rgba(" + TEAL + "," + (0.5 * l).toFixed(3) + ")";
          ctx.shadowBlur = 14 * l;
        }
        ctx.beginPath(); ctx.arc(x, y, rad, 0, 6.2832); ctx.fill();
        ctx.shadowBlur = 0;
      }
      ctx.globalAlpha = 1;
    }

    var last = 0, running = false, settled = false;
    function step(dt) {
      var moving = false;
      for (var i = 0; i < dots.length; i++) {
        var n = dots[i];

        /* where the cursor wants this dot to sit */
        var tx = 0, ty = 0, f = 0;
        var gx = mx - n.bx, gy = my - n.by;
        var d = Math.sqrt(gx * gx + gy * gy);
        if (d < REACH) {
          f = 1 - d / REACH;
          var reach = Math.min(d, PULL * Math.pow(f, 1.6));
          if (d > 0.001) { tx = (gx / d) * reach; ty = (gy / d) * reach; }
        }

        /* spring the offset toward that target */
        n.vx += ((tx - n.dx) * STIFF - n.vx * DAMP) * dt;
        n.vy += ((ty - n.dy) * STIFF - n.vy * DAMP) * dt;
        n.dx += n.vx * dt;
        n.dy += n.vy * dt;

        /* the swell trails the pointer slightly, so the pop feels physical */
        n.lift += (f - n.lift) * Math.min(1, dt * 9);

        if (!moving && (Math.abs(n.dx) > 0.05 || Math.abs(n.dy) > 0.05 ||
                        Math.abs(n.vx) > 0.05 || Math.abs(n.vy) > 0.05 || n.lift > 0.004)) {
          moving = true;
        }
      }
      return moving;
    }

    function loop(ts) {
      var dt = last ? (ts - last) / 1000 : 0; last = ts;
      if (dt > 0.05) dt = 0.05;
      var moving = step(dt);
      /* idle grid never repaints, no cost while the cursor is elsewhere */
      if (moving || !settled) { render(); settled = !moving; }
      if (running) requestAnimationFrame(loop);
    }

    function setCursor(clientX, clientY) {
      var rect = canvas.getBoundingClientRect();
      var x = clientX - rect.left, y = clientY - rect.top;
      if (x < -REACH || y < -REACH || x > W + REACH || y > H + REACH) { mx = -99999; my = -99999; }
      else { mx = x; my = y; }
      settled = false;
    }

    /* the canvas is pointer-events:none, so track on window and map into its box */
    window.addEventListener("mousemove", function (e) { setCursor(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener("touchmove", function (e) {
      if (e.touches && e.touches[0]) setCursor(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    window.addEventListener("touchend", function () { mx = -99999; my = -99999; settled = false; }, { passive: true });

    build();
    render();  /* the resting grid, also the static frame for reduced motion / JS-idle */
    if (willAnimate) { running = true; requestAnimationFrame(loop); }

    if ("ResizeObserver" in window) {
      var seenW = 0, seenH = 0;
      var ro = new ResizeObserver(function () {
        var r = canvas.getBoundingClientRect();
        if (Math.abs(r.width - seenW) < 1 && Math.abs(r.height - seenH) < 1) return;
        seenW = r.width; seenH = r.height;
        build(); render(); settled = false;
      });
      ro.observe(canvas);
    }
    var rz;
    window.addEventListener("resize", function () {
      clearTimeout(rz);
      rz = setTimeout(function () { build(); render(); settled = false; }, 150);
    });
  }
  document.querySelectorAll(".starfield").forEach(initDotField);

  /* ---------- INSIDE SRIX · the threshold (home) ----------
     The mark sits split on the door seam; as you scroll the doors part and
     each half rides its door out and twists. All of it is driven by one
     custom property, `--open` (0 shut, 1 fully parted), so the CSS owns the
     choreography and this only has to compute scroll progress.

     Gated behind `store-anim`, which is only added when animation is allowed:
     with JS off or under reduced motion the doors sit open and the mark is
     already clear of the frame. */
  var threshold = document.querySelector(".threshold");

  if (willAnimate && threshold) {
    document.documentElement.classList.add("store-anim");

    var stage = threshold.querySelector(".threshold-stage");
    var rafId = 0;

    function frame() {
      rafId = 0;
      if (!stage) return;
      var rect = threshold.getBoundingClientRect();
      var travel = rect.height - window.innerHeight;
      var p = travel <= 0 ? (rect.top <= 0 ? 1 : 0) : -rect.top / travel;
      if (p < 0) p = 0; else if (p > 1) p = 1;
      /* fully open by 62% of the travel, so the corridor is clear before you
         leave the section; smoothstepped so the doors ease rather than track */
      var open = p / 0.62;
      if (open > 1) open = 1;
      stage.style.setProperty("--open", (open * open * (3 - 2 * open)).toFixed(4));
    }

    /* cancel-and-requeue rather than a boolean latch: a frame queued while the
       tab is hidden can be dropped, and a latch would then never clear */
    function onScroll() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(frame);
    }

    stage.style.setProperty("--open", "0");
    frame();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") { rafId = 0; frame(); }
    });
  }

  /* ---------- STUDIO · the hero mesh ----------
     The blueprint grid, but alive: every vertex springs toward the cursor and
     the lines around it warm from tan to brown, so the grid leans in as you
     move over it and settles back when you leave.

     Cold segments (everything outside the cursor's reach) are batched into a
     single path and stroked once; only the ~150 segments near the pointer are
     drawn individually with their own colour. That keeps a full-viewport mesh
     to two-ish stroke calls plus a small hot set. */
  function initHeroMesh(canvas) {
    if (canvas.dataset.srixInit) return;
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    canvas.dataset.srixInit = "1";

    var css = getComputedStyle(document.documentElement);
    function token(name, fallback) {
      var v = css.getPropertyValue(name).trim();
      return v || fallback;
    }
    var TAN = token("--st-tan", "#9C7B62");
    var BROWN = token("--st-brown", "#3B2A20");

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, cols = 0, rows = 0, gap = 46;
    var pts = [];                 /* flat grid of vertices, row-major */
    var REACH = 210;              /* cursor influence radius */
    var PULL = 30;                /* max px a vertex travels toward the cursor */
    var STIFF = 165, DAMP = 13;   /* under-damped, so releasing gives a bounce */
    var mx = -99999, my = -99999;

    function idx(c, r) { return r * (cols + 1) + c; }

    function build() {
      var rect = canvas.getBoundingClientRect();
      W = rect.width; H = rect.height;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      gap = W < 640 ? 34 : 46;
      cols = Math.ceil(W / gap);
      rows = Math.ceil(H / gap);
      pts = [];
      for (var r = 0; r <= rows; r++) {
        for (var c = 0; c <= cols; c++) {
          pts.push({ bx: c * gap, by: r * gap, dx: 0, dy: 0, vx: 0, vy: 0, heat: 0 });
        }
      }
    }

    function step(dt) {
      var moving = false;
      for (var i = 0; i < pts.length; i++) {
        var n = pts[i];
        var tx = 0, ty = 0, f = 0;
        var gx = mx - n.bx, gy = my - n.by;
        var d = Math.sqrt(gx * gx + gy * gy);
        if (d < REACH) {
          f = 1 - d / REACH;
          var reach = Math.min(d, PULL * Math.pow(f, 1.5));
          if (d > 0.001) { tx = (gx / d) * reach; ty = (gy / d) * reach; }
        }
        n.vx += ((tx - n.dx) * STIFF - n.vx * DAMP) * dt;
        n.vy += ((ty - n.dy) * STIFF - n.vy * DAMP) * dt;
        n.dx += n.vx * dt;
        n.dy += n.vy * dt;
        n.heat += (f - n.heat) * Math.min(1, dt * 8);

        if (!moving && (Math.abs(n.dx) > 0.05 || Math.abs(n.dy) > 0.05 ||
                        Math.abs(n.vx) > 0.05 || Math.abs(n.vy) > 0.05 || n.heat > 0.004)) {
          moving = true;
        }
      }
      return moving;
    }

    /* one segment, hot or cold */
    function seg(a, b, cold) {
      var heat = a.heat > b.heat ? a.heat : b.heat;
      var ax = a.bx + a.dx, ay = a.by + a.dy;
      var bx = b.bx + b.dx, by = b.by + b.dy;
      if (heat < 0.02) { cold.moveTo(ax, ay); cold.lineTo(bx, by); return; }
      ctx.strokeStyle = heat > 0.5 ? BROWN : TAN;
      ctx.globalAlpha = 0.34 + heat * 0.62;
      ctx.lineWidth = 1 + heat * 1.1;
      ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke();
    }

    function render() {
      ctx.clearRect(0, 0, W, H);
      var cold = new Path2D();
      var c, r;
      for (r = 0; r <= rows; r++) {
        for (c = 0; c < cols; c++) seg(pts[idx(c, r)], pts[idx(c + 1, r)], cold);
      }
      for (c = 0; c <= cols; c++) {
        for (r = 0; r < rows; r++) seg(pts[idx(c, r)], pts[idx(c, r + 1)], cold);
      }
      ctx.strokeStyle = TAN;
      ctx.globalAlpha = 0.34;
      ctx.lineWidth = 1;
      ctx.stroke(cold);
      ctx.globalAlpha = 1;
    }

    var last = 0, running = false, settled = false, rafId = 0;
    function loop(ts) {
      rafId = 0;
      var dt = last ? (ts - last) / 1000 : 0; last = ts;
      if (dt > 0.05) dt = 0.05;
      var moving = step(dt);
      if (moving || !settled) { render(); settled = !moving; }
      if (running) rafId = requestAnimationFrame(loop);
    }

    function setCursor(clientX, clientY) {
      var rect = canvas.getBoundingClientRect();
      var x = clientX - rect.left, y = clientY - rect.top;
      if (x < -REACH || y < -REACH || x > W + REACH || y > H + REACH) { mx = -99999; my = -99999; }
      else { mx = x; my = y; }
      settled = false;
    }
    window.addEventListener("mousemove", function (e) { setCursor(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener("touchmove", function (e) {
      if (e.touches && e.touches[0]) setCursor(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    window.addEventListener("touchend", function () { mx = -99999; my = -99999; settled = false; }, { passive: true });

    build();
    render();
    document.documentElement.classList.add("grid-anim");
    running = true; rafId = requestAnimationFrame(loop);

    if ("ResizeObserver" in window) {
      var seenW = 0, seenH = 0;
      var ro = new ResizeObserver(function () {
        var r2 = canvas.getBoundingClientRect();
        if (Math.abs(r2.width - seenW) < 1 && Math.abs(r2.height - seenH) < 1) return;
        seenW = r2.width; seenH = r2.height;
        build(); render(); settled = false;
      });
      ro.observe(canvas);
    }
    var rz;
    window.addEventListener("resize", function () {
      clearTimeout(rz);
      rz = setTimeout(function () { build(); render(); settled = false; }, 150);
    });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible" && running && !rafId) {
        last = 0; settled = false; rafId = requestAnimationFrame(loop);
      }
    });
  }
  if (willAnimate) document.querySelectorAll(".hero-mesh").forEach(initHeroMesh);

  /* Waitlist posts to Shopify's customer form in this theme; the mock
     submit handler that lived here has been removed. */

  /* ---------- theme editor ----------
     The editor replaces one section's markup in place, without a reload, so
     anything that arrived that way has never been through the code above:
     its canvases are blank and its .reveal elements are stuck hidden behind
     `reveal-anim`. Re-scan just that section when it loads. The initialisers
     are guarded above, so a re-scan can never start the same canvas twice. */
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".starfield").forEach(initDotField);
    if (willAnimate) root.querySelectorAll(".hero-mesh").forEach(initHeroMesh);
    if (io) {
      root.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll("[data-count]").forEach(setFinal);
    }
  }
  window.SRIX = window.SRIX || {};
  window.SRIX.scan = scan;
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });

})();
